/* v8 ignore start -- @preserve */
import ReactDOM from "react-dom/client";
import { matchRoutes } from "react-router";

import {
  createReactRouterV7DataOptions,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { swaggerAxiosInstance } from "@vega-api/configs/customInstance";
import { MSW_BASE_URL } from "@vega-core/constants/global";
import { getAppConfig } from "@vega-core/utils/appConfig";
import { faroBeforeSend } from "@vega-core/utils/faroBeforeSend";
import { isF2F, isMSW } from "@vega-core/utils/global";
import { setupCrashReporting } from "@vega-core/utils/setupCrashReporting";

import "@vega-core/utils/browserPolyfills";

import { App } from "./App";

const { mode, version } = getAppConfig();

initializeFaro({
  url: "/faro/collect/5fafa5c83410e4b2819502f47a0ff2cf",
  paused: mode === "local",
  app: {
    name: "Frontend Co-Invest GP",
    version: version ?? "local",
    environment: mode,
  },
  ignoreErrors: [
    "CanceledError",
    "console.error: Error during Axios request: CanceledError: canceled",
    "canceled",
  ],
  beforeSend: faroBeforeSend,
  batching: {
    enabled: true,
    sendTimeout: 5000,
    itemLimit: 100,
  },

  instrumentations: [
    // Mandatory, omits default instrumentations otherwise.
    ...getWebInstrumentations(),
    // Tracing package to get end-to-end visibility for HTTP requests.
    new TracingInstrumentation(),
    // React integration for React applications.
    new ReactIntegration({
      router: createReactRouterV7DataOptions({
        matchRoutes,
      }),
    }),
  ],
});

setupCrashReporting();

const initializeApp = async () => {
  if (isMSW && !isF2F) {
    swaggerAxiosInstance.defaults.baseURL = MSW_BASE_URL;
    const { worker } = await import("@vega-api/custom/testSetup/setupWorker");
    await worker.start();
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(<App />);
};

initializeApp();
